import { useTranslation } from "react-i18next";
import { formatNumber } from "../../../utils/formatNumber";
import { WITHDRAW_AMOUNT_MIN } from "../../../constant";

const WithdrawNotice = () => {
  const { t } = useTranslation();
  const i18n_withdraw = (key, props) => t(`withdraw.${key}`, { ...props });
  return (
    <>
      <span className="text-xl text-main-color">
        {i18n_withdraw("notice")}：
      </span>
      <section className="flex flex-col gap-[10px] bg-transaction-card dark:bg-base-light-dark dark:text-base-light-white rounded-[5px] py-[8px] px-[5px]">
        <span className="text-base text-sm">1. {i18n_withdraw("hint.1")}</span>
        <span className="text-base text-sm">
          2.{" "}
          {i18n_withdraw("hint.2", {
            withdraw_limit: formatNumber(WITHDRAW_AMOUNT_MIN, { point: false }),
          })}
        </span>
        <span className="text-base text-sm">
          3. {i18n_withdraw("hint.3", { times: 2 })}
        </span>{" "}
        <span className="text-base text-sm">4. {i18n_withdraw("hint.4")}</span>
      </section>
    </>
  );
};

export default WithdrawNotice;
